import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Can from '../../../components/Can';
import { useTranslation } from "react-i18next";
import SideBarSubMenuItem from '../SideBarSubMenuItem';
import SideBarMenuCollapseItem from '../SideBarMenuCollapseItem';

const SideBarScheduleMenu = () => {
    const { t } = useTranslation();
    return (
        <Can do="read" on='ScheduleEntry'>
            <SideBarMenuCollapseItem icon={<CalendarTodayIcon />} type="schedule" text={t("schedule")}>
                <SideBarSubMenuItem
                    id="side_menu_item_schedule"
                    to="/schedule"
                    text={t("schedule")} />
                <Can do="manage" on='ScheduleEntry'>
                    <SideBarSubMenuItem
                        id="side_menu_item_schedule_analysis"
                        to="/schedule/analysis"
                        text={t("analysis")} />
                </Can>
                <Can do="manage" on='ScheduleEntry'>
                    <SideBarSubMenuItem
                        id="side_menu_item_schedule_speeches"
                        to="/schedule/speech"
                        text={t("speeches")} />
                </Can>
                <Can do="manage" on='ScheduleEntry'>
                    <SideBarSubMenuItem
                        id="side_menu_item_schedule_students"
                        to="/schedule/students"
                        text={t("students")} />
                </Can>
            </SideBarMenuCollapseItem>
        </Can>
    )
}

export default SideBarScheduleMenu;
